import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IPagination } from "app/types";
import { TimeZones } from "../type";
import { initialState } from "./initialState";

export const useClinicSlice = createSlice({
  name: "timeZoneState",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setPagination: (state, action: PayloadAction<IPagination>) => {
      state.pagination = action.payload;
    },
    doFetchList: (state) => {
      state.isLoading = true;
    },
    setList: (state, action: PayloadAction<TimeZones[]>) => {
      const mappedOptions = action.payload.map((tz) => ({
        label: tz.text, // use text as the label
        value: tz._id, // keep value
        abbr: tz.abbr,
        createdAt: tz.createdAt,
        offset: tz.offset,
        updatedAt: tz.updatedAt,
        utc: tz.utc,
        _id: tz._id,
        text: tz.text,
      }));
      if (state.pagination.page === 1) {
        state.list = mappedOptions;
      } else {
        state.list = [...state.list, ...mappedOptions];
      }
    },
  },
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
